import { createEmptyAction, createMapAction } from "chalet-shared";

export const actionCreators = {
    onBetaLoginFailed: createMapAction("ON_BETA_LOGIN_FAILED", (message?: string) => message),
    createOAuthState: createEmptyAction("CREATE_OAUTH_STATE"),
    createOAuthStateFailed: createMapAction("CREATE_OAUTH_STATE_FAILED", (x: { err: any }) => x),
};
